import React, { useState, useEffect } from "react";
import {
    Paper,
    Typography,
    makeStyles,
    TextField,
    Grid,
    FormControl,
    Button,
    Select,
    InputLabel,
    MenuItem,
    AppBar,
    IconButton,
    Dialog,
    Toolbar,
    Tooltip,
    DialogContent,
    Backdrop,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import { connect, useDispatch, useSelector } from "react-redux";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import Feedback from "../../../atoms/Feedback";
import { getUsersList, getProfile } from "../../../../actions/userActions";
import { createCRF, getCRFs } from "../../../../actions/ppmActions/changeMgtActions";

const useStyles = makeStyles((theme) => ({
    title: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        marginBottom: 20,
        fontWeight: "bold",
    },
    title2: {
        display: "block",
        fontSize: 12,
        color: theme.palette.type === "light" ? theme.palette.grey[600] : "#fff",
        fontWeight: "bold",
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        marginBottom: 10,
    },
    title3: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
    },
    appBar: {
        zIndex: 9000,
    },
    container: {
        marginTop: theme.spacing(6),
        padding: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
    },
    option: {
        fontSize: 15,
        "& > span": {
            marginRight: 10,
            fontSize: 18,
        },
    },
    textField: {
        marginBottom: theme.spacing(3),
    },
    paper2: {
        padding: "2px 20px 2px 5px",
        width: "60%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
            width: "100%",
        },
        "&:nth-of-type(2n)": {
            color: theme.palette.background.paper,
            backgroundColor: theme.palette.primary.main,
        },
    },
    dialogContent: {
        [theme.breakpoints.down("sm")]: {
            padding: "8px 14px",
        },
    },
    tabPanel: {
        padding: 14,
    },
    divider: {
        marginBottom: 10,
    },
    divider2: {
        height: 28,
        margin: 4,
    },
    total: {
        marginTop: 40,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1000000,
        color: "#fff",
    },
    warningInfo: {
        color: "#f5f5f5",
        background: "#f44336",
        padding: 20,
        marginBottom: 20,
        marginRight: 10,
        "& > *": {
            fontWeight: 900,
        },
    },
    form: {
        marginTop: 20,
    },
    grid: {
        marginBottom: 20,
    },
    input: {
        border: "1px solid #bdbdbd",
        padding: theme.spacing(2),
        borderRadius: 3,
    },

    btnWrapper: {
        textAlign: "center",
    },

    saveBtn: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 300,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
}));

const INIT_STATE = {
    employee: "",
    employeeName:"",
    employeeId:"",
    division: "",
    divisionName:"",
    month: "",
    year: "",
    applicationType: "",
    forWhom: "",
    internalUser: null,
    externalUser: null,
    
    riskFactors: "",
    opportunityFactors: "",
    trainingRequired: "",
    reason: "",
    recommendation: "",
};

const CreateTrainingRequestModal = ({ openCreate, handleCloseCreate, createCRF }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [feed, setFeed] = useState({
        loading: false,
        open: false,
        message: "",
        success: false,
    });

    const [requestDate] = useState(moment(new Date()));
    const [dueDate, setDueDate] = useState("");
    const [returnDate, setReturnDate] = useState("");
    const [month] = useState(moment().format("MMMM"));
    const [year] = useState(moment().format("YYYY"));
    const [state, setState] = useState(INIT_STATE);
    
    const { profile } = useSelector((state) => state.user);
    const { ppmusers } = useSelector((state) => state.user);
    const { loading, error } = useSelector((state) => state.changeMgt);

    useEffect(() => {
        if (error && error !== null) {
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: error,
                success: false,
            }));
        }
    }, [error]);

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            employee: profile && profile._id,
            employeeName: profile && profile.userName,
            employeeId: profile && profile.employeeId,
            month: month,
            year: year,
            requestDate: moment(requestDate).toDate(),
            division: profile && profile.division && profile.division._id,
            divisionName: profile && profile.division && profile.division.name,
        }));
    }, [profile, year, month, requestDate]);

    useEffect(() => {
        dispatch(getProfile());
        dispatch(getUsersList())
    }, [dispatch]);

    const handleChangeDueDate = (date) => {
        setDueDate(date);
    };

    const handleChangReturnDate = (date) => {
        setReturnDate(date);
    };

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleCloseFeed = () => {
        setFeed((prevState) => ({ ...prevState, open: false }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            ...state,
        };
        
        const res = await new Promise((resolve, reject) => {
            resolve(createCRF(data));
        });
        
        if (res) {
            dispatch(getCRFs());
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: "Travel Arrangement Request Created Successfully.",
                success: true,
            }));
            setTimeout(() => {
                handleCloseCreate();
            }, 2000);
        }
    };

    const validCheck = () =>
        !state.division ||
        !state.employee ||
        !state.requestDescription ||
        !state.justification || 
        !state.priority || 
        !state.budgetProjection ||
        !state.resourceRequirements ||
        // !state.riskFactors ||
        // !state.opportunityFactors ||
        (state.timelines.length === 0) ||
        (state.outcomes.length === 0);

    return (
        <div>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                {feed.success ? (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="success"
                        message={feed.message}
                    />
                ) : (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="error"
                        message={feed.message}
                    />
                )}
                <Dialog
                    open={openCreate}
                    onClose={handleCloseCreate}
                    aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    fullScreen
                    maxWidth="md"
                >
                    <AppBar
                        className={classes.appBar}
                        variant="elevation"
                        position="fixed"
                        color="inherit"
                    >
                        <Toolbar>
                            <Tooltip title="close" arrow>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={handleCloseCreate}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Tooltip>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        <form onSubmit={handleSubmit}>
                            <div className={classes.container}>
                                <Typography variant="overline" className={classes.title}>
                                    Create Training Request
                                </Typography>

                                <Grid container spacing={2} className={classes.grid}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                        label="Change Initiator"
                                        name="employeeName"
                                        variant="outlined"
                                        fullWidth
                                        onChange={handleChange}
                                        value={(state.employeeName && state.employeeName) || ""}
                                        disabled
                                        required
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            label="EID"
                                            name="employeeId"
                                            variant="outlined"
                                            fullWidth
                                            onChange={handleChange}
                                            value={state.employeeId || ""}
                                            disabled
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <DatePicker
                                            className={classes.marginBottom}
                                            autoOk
                                            format="DD/MM/yyyy"
                                            views={["year", "month", "date"]}
                                            label="Request Date"
                                            fullWidth
                                            required
                                            name="requestDate"
                                            inputVariant="outlined"
                                            value={state.requestDate}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            label="Division/Unit"
                                            name="division"
                                            variant="outlined"
                                            fullWidth
                                            value={(state.division && state.divisionName) || ""}
                                            disabled
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth variant="outlined" required>
                                            <InputLabel>Application Type</InputLabel>
                                            <Select
                                                inputProps={{
                                                    id: "applicationType",
                                                    name: "applicationType",
                                                }}
                                                value={state.applicationType || ""}
                                                onChange={handleChange}
                                            >
                                                <MenuItem disabled>Select Option</MenuItem>
                                                <MenuItem value="New">New</MenuItem>
                                                <MenuItem value="Reissue">Re-issue</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth variant="outlined" required>
                                            <InputLabel>Are you filling on behalf of someone else?</InputLabel>
                                            <Select
                                                inputProps={{
                                                    id: "forWhom",
                                                    name: "forWhom",
                                                }}
                                                value={state.forWhom || ""}
                                                onChange={handleChange}
                                            >
                                                <MenuItem disabled>Select Option</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="Yes">Yes</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {(state.forWhom === "Yes") && (<>
                                        <Grid item xs={12} md={3}>
                                            <FormControl fullWidth variant="outlined" required>
                                                <InputLabel>External User / Internal User</InputLabel>
                                                <Select
                                                    inputProps={{
                                                        id: "userType",
                                                        name: "userType",
                                                    }}
                                                    value={state.userType || ""}
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem disabled>Select Option</MenuItem>
                                                    <MenuItem value="Internal">Internal User</MenuItem>
                                                    <MenuItem value="External">External User</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        {(state.userType === "External") && ( <>
                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    label="Name"
                                                    name="name"
                                                    value={state.name || ""}
                                                    onChange={handleChange}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    label="Email"
                                                    name="email"
                                                    value={state.email || ""}
                                                    onChange={handleChange}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    label="Phone Number"
                                                    name="phoneNumber"
                                                    value={state.phoneNumber || ""}
                                                    onChange={handleChange}
                                                />
                                            </Grid>
                                        </>)}
                                        {(state.userType === "Internal") && ( <>
                                            <Grid item xs={12} md={3}>
                                                <Autocomplete
                                                    id="ppmusers"
                                                    options={ppmusers}
                                                    value={state.internalUser}
                                                    debug
                                                    onChange={(event, newValue) => {
                                                        setState((prev) => ({
                                                            ...prev,
                                                            internalUser: newValue,
                                                        }));
                                                    }}
                                                    getOptionLabel={(option) => option.userName || ""}
                                                    renderOption={(option) => (
                                                        <React.Fragment>{option.userName}</React.Fragment>
                                                    )}
                                                    renderInput={(params) => (
                                                        <>
                                                            <TextField
                                                                {...params}
                                                                placeholder="Search by Name"
                                                                fullWidth
                                                                required
                                                                variant="outlined"
                                                                value={(state.internalUser && state.internalUser) || ""}
                                                                inputProps={{
                                                                    ...params.inputProps,
                                                                    autoComplete: "disabled",
                                                                    name: "internalUser",
                                                                }}
                                                            />
                                                        </>
                                                    )}
                                                />
                                            </Grid>
                                            {state.internalUser && (<>
                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    label="Employee Name"
                                                    name="internalUserName"
                                                    value={state.internalUser?.userName || ""}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    label="Employee Email"
                                                    name="internalUserEmail"
                                                    value={state.internalUser?.email || ""}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    label="Employee ID"
                                                    name="internalUserEmployeeId"
                                                    value={state.internalUser?.employeeId || ""}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    label="Employee Division"
                                                    name="internalUserDivisionId"
                                                    value={state.internalUser?.division?.name || ""}
                                                    disabled
                                                />
                                            </Grid>
                                            </>)}
                                        </>)}
                                    </>)}
                                </Grid>

                                <Typography variant="overline" className={classes.title2}>
                                    Travel Details
                                </Typography>

                                <Paper variant="outlined" square className={classes.paper}>
                                    <Grid
                                        container
                                        spacing={2}
                                        className={classes.grid}
                                    >
                                        <Grid item xs={12} md={7}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                label="Action"
                                                name="action"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DatePicker
                                                className={classes.marginBottom}
                                                autoOk
                                                format="DD/MM/yyyy"
                                                views={["year", "month", "date"]}
                                                fullWidth
                                                required
                                                inputVariant="outlined"
                                                label="Proposed Date of Departure"
                                                name="dueDate"
                                                value={(dueDate ? moment(dueDate).toDate() : state.date) || ""}
                                                onChange={handleChangeDueDate}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <FormControl fullWidth variant="outlined" required>
                                                <InputLabel>Is Return Needed?</InputLabel>
                                                <Select
                                                    inputProps={{
                                                        id: "returnNeeded",
                                                        name: "returnNeeded",
                                                    }}
                                                    value={state.returnNeeded || ""}
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem disabled>Select Option</MenuItem>
                                                    <MenuItem value="No">No</MenuItem>
                                                    <MenuItem value="Yes">Yes</MenuItem>                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        {(state.returnNeeded === "Yes") && (<>
                                        <Grid item xs={12} md={4}>
                                            <DatePicker
                                                className={classes.marginBottom}
                                                autoOk
                                                format="DD/MM/yyyy"
                                                views={["year", "month", "date"]}
                                                fullWidth
                                                required
                                                inputVariant="outlined"
                                                label="Return Date"
                                                name="returnDate"
                                                value={(returnDate ? moment(returnDate).toDate() : state.date) || ""}
                                                onChange={handleChangReturnDate}
                                            />
                                        </Grid>


                                        </>)}
                                        <Grid item xs={12} md={3}>
                                            <FormControl fullWidth variant="outlined" required>
                                                <InputLabel>Class of Ticket</InputLabel>
                                                <Select
                                                    inputProps={{
                                                        id: "ticketClass",
                                                        name: "ticketClass",
                                                    }}
                                                    value={state.ticketClass || ""}
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem disabled>Select Option</MenuItem>
                                                    <MenuItem value="Economy">Economy</MenuItem>
                                                    <MenuItem value="Premium Economy">Premium Economy</MenuItem>
                                                    <MenuItem value="Business">Business</MenuItem>
                                                    <MenuItem value="First">First</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Paper>

                                <div className={classes.btnWrapper}>
                                    <Button
                                        type="submit"
                                        className={classes.saveBtn}
                                        disabled={loading || validCheck()}
                                        color="primary"
                                        variant="contained"
                                    >
                                        {loading ? "Loading..." : "Save"}
                                    </Button>
                                </div>
                            </div>
                        </form>
                        <Backdrop className={classes.backdrop} open={loading}>
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </DialogContent>
                </Dialog>
            </MuiPickersUtilsProvider>
        </div>
    );
};

export default connect(null, { createCRF, getCRFs })(CreateTrainingRequestModal);
